<template>
    <div class="wbs-wrap" style="position:relative">
        <!-- Spinner -->
      <loading :active="loading" :is-full-page="false" />
        <!-- /Spinner -->
      <b-card no-body-header="header" class="rounded">
        <div>
          <div style="display: flex; align-items: end">
            <project-filter @changeProject="changeProjectFilterHadnler" 
                            @changeWithClosed="changeWithClosedOptionHandler"
                            :defaultStatus="withClosedProject" 
                            :selectedProjectId="projectId" 
                            :customStyle="{display:'flex', justifyContent: 'center', alignItems: 'start'}"/>
            <button v-if="this.projectId" @click="configureDefaultProject" style="background-color: transparent; border: none;">
                <!-- <b-icon icon="star-fill" style="color: orange;" /> -->
                <b-icon :icon="defaultProjectIcon" style="color: orange;"/>
            </button>
          </div>
          <wbs-filter @searchWbs="searchWbsFilterHandler" @resetWbs="resetWbsFilterHandler" v-if="projectId != '' && wbs.length > 0" 
            :projectId="projectId" :devMethodologyList="wbs"/>
        </div>
      </b-card>
      <b-card class="rounded" v-if="this.projectId && filteredWbs.length > 0">
        <div>
          <wbs-table  
            :devMethodologyList="filteredWbs" :startDate="startDate" :endDate="endDate" 
            :total="totalChatterCount"
            :toDo="toDoChatterCount"
            :inProgress="inProgressChatterCount"
            :done="doneChatterCount"
            :cancelled="cancelledChatterCount"
            :closed="closedChatterCount" 
            :progress="projectProgress" 
            :key="this.projectId"/>
          <!-- <wbs-timeline-graph v-if="this.projectId" :projectId='this.projectId' :devMethodologyList="filteredWbs"/> -->
        </div>
      </b-card>
      <empty-card v-else>
          <div style="display: flex; flex-direction: column; align-items: center;">
              <img style="width: 170px; height: 170px;" :src="pointerIcon" />
              <span>Please select a project</span>
          </div>
      </empty-card>
    </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import ProjectFilter from './ProjectFilter.vue';
  import WbsTable from './WbsTable.vue';
  import WbsFilter from './WbsFilter.vue';
  import EmptyCard from '../common/EmptyCard.vue';
  import PointerIcon from "@/assets/images/select_pointer.svg";

  export default {
    name : 'ProjectWbs',
    components : {
      Loading,
      ProjectFilter,
      WbsTable,
      WbsFilter,
      EmptyCard
    },
    async created() {

      await this.$store.dispatch('chatter/retrieveAllProjectInfo');
      const defaultProjectId = await this.getDefaultProjectId();
      this.defaultProjectId = defaultProjectId;

      if (this.projectId) {
        await this.getProjectWbsData(this.projectId);
        this.getExpandableItemCount(this.filteredWbs);
        return;
      } 
      //toggle 여부에 따라 보이는 project 다르게
      // 로그인한 사용자가 참여하고 있는 Open상태의 프로젝트의 개수가 하나라면 해당 프로젝트를 기본 프로젝트로 설정
      let projectOptions = this.$store.getters['chatter/options']['projectOptions'];
      if(defaultProjectId) {
        const findProject = projectOptions.find(project => project.projectId === defaultProjectId);
        const defaultProjectStatus = findProject.status;
        if (defaultProjectStatus === "CLOSED") {
          this.changeWithClosedOptionHandler(true);
        }
        this.defaultProjectId = defaultProjectId;
        this.changeProjectFilterHadnler(defaultProjectId);

        return;
      }

      const openProjectOptions = projectOptions.filter(project => project.status == "OPEN");
      if (openProjectOptions.length === 1) {
        const openProject = openProjectOptions[0];
        this.changeProjectFilterHadnler(openProject.projectId);
        // this.$store.commit('requirement/updateFilter', { projectId: openProject.projectId });
        // this.fetchRequirements();
      }
    },
    computed: {
      projectId() {
        return this.$store.getters['wbs/projectId'];
      },
      withClosedProject() {
        return this.$store.getters['wbs/withClosedProject'];
      },
      expandableItemCount() {
        return this.$store.getters['wbs/getExpandableItemCount'];
      },
      defaultProjectIcon() {
          return this.projectId === this.defaultProjectId ? 'star-fill' : 'star';
      },
    },
    data() {
      return {
        defaultProjectId: '',
        pointerIcon: PointerIcon,
        projectProgress : 0.0,
        totalChatterCount: 0,
        toDoChatterCount: 0,
        inProgressChatterCount: 0,
        doneChatterCount: 0,
        cancelledChatterCount: 0,
        closedChatterCount: 0,
        startDate: '',
        endDate: '',
        startDateFirstDay: '',
        endDateLastDay: '',
        loading : false,
        wbs: [],
        filteredWbs : [],
        filter: {
          l1: '',
          l2: '',
          l3: '',
          status: '',
          assignee: '',
          startDate: '',
          dueDate: '',
          keyword: ''
        }
      }
    },
    methods: {

      configureDefaultProject() {
        if (!this.projectId) return;

        const prevDefaultProjectId = this.defaultProjectId;

        if (this.projectId === this.defaultProjectId) {
            this.defaultProjectId = '';
        } else {
            this.defaultProjectId = this.projectId;
        }

        const params = {
            projectId: this.defaultProjectId
        }

        try {
          axios.post('/chatter/configureDefaultProject', params, {
              headers: {
                  'Accept': 'application/json',
                  Authorization: accessToken()
              }
          }).then(response => {
              if (response.data.status === "200") {
                  this.defaultProjectId = response.data.body.projectId;
              } else {
                  this.defaultProjectId = prevDefaultProjectId;
              }
          })
        } catch(e) {
            this.defaultProjectId = prevDefaultProjectId;
        }
      },
      async getDefaultProjectId() {
          try {
            const response = await axios.get("/chatter/getDefaultProject", {
                headers: {
                    'Accept': 'application/json',
                    Authorization: accessToken()
                }
            })

            const status = response.data.status;

            if (status === "200") {
                const defaultProjectId = response.data.body.projectId;
                return defaultProjectId ? defaultProjectId : '';
            } else {
                return ''
            }
          } catch(e) {
            console.log(e);
            return ''
          }
      },
      async changeProjectFilterHadnler(projectId) {
        this.$store.commit('wbs/setProjectId', projectId);
        this.$store.commit('wbs/resetExpanded');
        this.$store.commit('wbs/setWbsScheduleChartExpandState', false);

        await this.getProjectWbsData();
        this.getExpandableItemCount(this.filteredWbs)
      },
      changeWithClosedOptionHandler(withClosed) {
        this.$store.commit('wbs/setWithClosedProject', withClosed);
      },
      searchWbsFilterHandler(searchFilter) {
        this.filter = {...searchFilter};
        try {
          this.loading = true;
          this.filteredWbs = this.depthFirstSearch();
          this.getExpandableItemCount(this.filteredWbs);
        } catch(e) {
          this.filteredWbs = [];
          this.getExpandableItemCount(this.filteredWbs);
          this.loading = false;
        } finally {
          this.loading = false;
        }
      },

      resetWbsFilterHandler(emptyFilter) {
        this.filter = emptyFilter;
        this.filteredWbs = this.wbs;
        // expand 상태 초기화
        this.$store.commit('wbs/resetExpanded');
      },

      depthFirstSearch() {
        // 필터조건에 맞는 wbs만 검색
        // 우선순위 정리
        // 1. L1 ~ L3 까지의 필터값이 있다면 해당 범위 안에서의 Chatter를 검색하고, L에 대한 row도 노출
        // 2. L1 ~ L3 까지의 필터값이 없고, status, assignee 등 세부사항 검색값만 있다면 해당 조건에 만족하는 모든 Chatter를 L값과 상관없이 낱개로 노출하도록 함
        const DEV_METHODOLOGY_MAX_DEPTH = 3;

        // 복잡도가 높은 객체 배열에 필터링을 진행하며 원본을 회손시킬 가능성이 있어
        // 깊은 복사 진행
        const wbs = JSON.parse(JSON.stringify(this.wbs));

        let devMethodology = wbs;
        
        for(let i = 1; i <= DEV_METHODOLOGY_MAX_DEPTH; i++) {
          // l1 ~ l3 까지 필터를 확인해서 값이 있으면 필터 적용
          let targetStep = this.filter['l' + i];
          if(targetStep != '') {
            if(i == 1) {
              devMethodology.forEach(item=>{
                if(item.step === targetStep) {
                  devMethodology = [item];
                }
              });
            } else {
              devMethodology[0].children.forEach(item => {
                if(item.step === targetStep) {
                  devMethodology = [item];
                }
              });
            }
          } else {
            break;
          }
        }

        // 상세조회 조건 (L1 ~ L3 제외)에 대한 필터값이 있으면 subChatter 조회
        let searchDetailFlag = false;
        
        const searchDetailFields = ['status', 'assignee', 'startDate', 'dueDate', 'keyword'];

        for(let field of searchDetailFields) {
          if(this.filter[field] != '') {
            searchDetailFlag = true; 
            break;
          }
        };
        
        // 상세조회 값이 없으면 devMethodology 리턴
        if(!searchDetailFlag) {
          return devMethodology;
        } 

        // 상세조회 값이 있으면 위에서 먼저 필터링한 devMethodology를 바탕으로 묶여있는 하위 Chatter들을 필터링하여 
        // 1차원 배열로 조회

        let filteredChatterResult = [];

        // TODO 검색 로직
        // 방안
        // 1. 모든 devMethodology에 대해 깊이 탐색을 하면서 ChatterList를 하나의 배열로 합친 후 필터링 및 정렬
        devMethodology.forEach(item => {
          filteredChatterResult = filteredChatterResult.concat(this.searchRootChatterList(item));
        });

        // chatId를 기준으로 내림차순 정렬
        filteredChatterResult.sort((a, b) =>{
          const aChatId = parseInt(a.chatId.substring(1), 10);
          const bChatId = parseInt(b.chatId.substring(1), 10);

          return bChatId - aChatId;
        })

        return filteredChatterResult;
      },
      searchRootChatterList(devMethodology) {
        let searchResult = [];

        devMethodology.chatterList.forEach(rootChatter => {
          // 파라미터로 넘겨준 Chatter의 모든 SubChatter들을 가져옴 (필터링 적용)
          const searchResultSubChatterList = this.searchSubChatterList(rootChatter)
          
          // 배열 하나에 동일한 깊이로 합칠 것이기 때문에 하위Chatter를 가저온 이후에 subChatter를 빈 배열로 만듬
          // 해당 함수의 목적은 트리구조의 데이터를 1차원 배열에 모든 Chatter가 동일한 깊이로 조회되는 것을 목적으로 함
          rootChatter.subChatterList = [];

          searchResult = searchResult.concat(searchResultSubChatterList);
        });

        // 필터링 로직 추가
        const fileredResult = devMethodology.chatterList.filter(item => this.isValidFilter(item));

        searchResult = searchResult.concat(fileredResult);
        
        if(devMethodology.children.length == 0) {
          return searchResult;
        }
        
        devMethodology.children.forEach(nextDevMethodology => {
          const searchResultRootChatterList = this.searchRootChatterList(nextDevMethodology);
          if(searchResultRootChatterList.length > 0) {
            searchResult = searchResult.concat(searchResultRootChatterList);
          }
        });

        return searchResult;
      },

      searchSubChatterList(chatter) {
        let searchResult = [];

        if(!chatter.subChatterList || chatter.subChatterList.length == 0) {
          return searchResult;
        }

        // 인자로 받은 Chatter의 SubChatter들을 하나씩 접근하면서 해당 Chatter의 SubChatter들을 다시 재귀형식으로 호출하여
        // 배열하나에 합쳐 리턴
        chatter.subChatterList.forEach(subChatter => {
          const searchResultSubChatterList = this.searchSubChatterList(subChatter);

          // subChatter의 모든 깊이의 노드를 탐색하면서 searchResultSubChatterList에 리턴하였으므로
          // 현재 접근하고 있는 subChatter의 subChatterList를 빈 배열로 초기화 시켜줘야 테이블에서 계층 구조를 그리지 않음
          // 해당 함수의 목적은 트리구조의 데이터를 1차원 배열에 모든 Chatter가 동일한 깊이로 조회되는 것을 목적으로 함
          subChatter.subChatterList = [];
          if(searchResultSubChatterList.length > 0) {
            searchResult = searchResult.concat(searchResultSubChatterList);
          }
        });

        // 필터링 로직 추가
        const filteredResult = chatter.subChatterList.filter(item => this.isValidFilter(item));

        searchResult = searchResult.concat(filteredResult);

        return searchResult;
      },
      getRootChatterStatus(devMethodology) {
        let isClosed = true;

        for(let i = 0; i < devMethodology.chatterList.length; i++) {
          if(!this.getSubChatterStatus(devMethodology.chatterList[i])) {
            isClosed = false;
            break;
          } 
        }
        
        if(isClosed) {
          for(let i = 0; i < devMethodology.children.length; i++) {
            if(!this.getRootChatterStatus(devMethodology.children[i])) {
                isClosed = false;
                break;
            }
          }
        }
        devMethodology.status = isClosed ? "CLOSED" : "OPEN";
        return isClosed;
      },
      getSubChatterStatus(chatter) {
        if(chatter.status !== "CLOSED" && chatter.status !== "CANCELLED") {
          return false;
        }

        for(const subChatter of chatter.subChatterList) {
          if(!this.getSubChatterStatus(subChatter)) {
              return false;
          }
        }

        return true;
      },
      isValidFilter(chatter) {

        // Status 필터
        if(this.filter.status != "") {
          let matchStatus = true; 
          switch (this.filter.status) {
            case 'OPEN':
              const openStatusArray = ['TO_DO', 'IN_PROGRESS', 'DONE', 'CANCELLED'];
              matchStatus = openStatusArray.includes(chatter.status);
              break;
            case 'ACTIVE':
              const activeStatusArray = ['TO_DO', 'IN_PROGRESS'];
              matchStatus = activeStatusArray.includes(chatter.status);
              break;
            default:  

              matchStatus = this.filter.status === chatter.status;
              break;
          }
          if(!matchStatus) {
            return false;
          }
        }

        // Assignee 필터
        if(this.filter.assignee != "" && chatter.assignee != this.filter.assignee) {
          return false;
        }

        // startDate 필터
        if(this.filter.startDate!= '') {
          if(chatter.startDate == '-' || this.compareDates(this.filter.startDate, chatter.startDate) > 0) {
            return false;
          }
        }

        // dueDate 필터
        if(this.filter.dueDate != '') {
          if(chatter.dueDate == '-' || this.compareDates(this.filter.dueDate, chatter.dueDate) < 0) {
            return false;
          }
        }

        const keyword = this.filter.keyword.trim().toLowerCase();
        // keyword 필터 (title, status, assignee, startDate, dueDate중 필터링)
        if(keyword != '') {
          if(chatter.title.toLowerCase().includes(keyword)) return true;
          if(chatter.status.toLowerCase().includes(keyword)) return true;
          if(chatter.assignee.toLowerCase().includes(keyword)) return true;
          if(chatter.userName.toLowerCase().includes(keyword)) return true;
          if(chatter.startDate.toLowerCase().includes(keyword)) return true;
          if(chatter.dueDate.toLowerCase().includes(keyword)) return true;

          return false;
        }

        return true;
      },

      async getProjectWbsData() {
        if(this.projectId == "") {
          this.wbs = [];
          this.filteredWbs = this.wbs;
          return;
        }

        let project = '';
        const projectList = this.$store.getters['chatter/options'].projectOptions;
        for(let i = 0; i < projectList.length; i++) {
          if(projectList[i].projectId === this.projectId) {
            project = projectList[i];
            break;
          }
        }

        if(project) {
          this.startDate = project.startDate;
          if(this.startDate !== '') {
            // 객체로 변경
            const startDateObj = new Date(this.startDate);

            // 1일 초기화 후 문자열로 변경
            this.startDateFirstDay = this.formatDateObjectToString(new Date(startDateObj.getFullYear(), startDateObj.getMonth(), 1)); 
          }
          this.endDate = project.endDate;
          if(this.endDate !== '') {
            // 객체로 변경
            const endDateObj = new Date(this.endDate);

            // 1일 초기화 후 문자열로 변경
            this.endDateLastDay = this.formatDateObjectToString(new Date(endDateObj.getFullYear(), endDateObj.getMonth() + 1, 0)); 
          }
        }

        try {
          this.loading = true;
          const response = await axios.get("chatter/retrieveWbs/" + this.projectId, {
              headers: { Accept: 'application/json', Authorization: accessToken() }
          });
          this.wbs = response.data.wbs;
          this.projectProgress = response.data.projectProgress;
          this.toDoChatterCount = response.data.toDoChatterCount;
          this.inProgressChatterCount = response.data.inProgressChatterCount;
          this.doneChatterCount = response.data.doneChatterCount;
          this.cancelledChatterCount = response.data.cancelledChatterCount;
          this.closedChatterCount = response.data.closedChatterCount;
          this.totalChatterCount = response.data.totalChatterCount; 
          
          // for(const item of this.wbs) {
          //   console.log(item);
          //   this.getScheduleByDevMethodology(item);
          // }
          this.wbs.forEach(item => {
            this.getScheduleByDevMethodology(item);
          })
          this.filteredWbs = [...this.wbs];
        } catch {
          this.loading = false;
        } finally {
          this.loading = false;
        }      
      },
      
      getScheduleByDevMethodology(devMethodology) {
        // 자신의 하위 Chatter들의 스케줄 구하기
        const chatterList = devMethodology.chatterList;
        if(chatterList !== undefined) {
          for(const chatter of chatterList) {
            this.getScheduleByChatter(chatter);
          }
        }
        // 자신의 스케줄 구하기
      
        const scheduleInfo = this.getSchedule(devMethodology.startDate, devMethodology.endDate);
        
        devMethodology.offset = scheduleInfo.offset;
        devMethodology.occupancy = scheduleInfo.occupancy;
        devMethodology.isOverdue = this.getOverdue(devMethodology.status, devMethodology.endDate);
        // 자신의 하위 devMethodology들의 스케줄 구하기
        const childrenList = devMethodology.children;
        // console.log(childrenList);
        if(childrenList !== undefined) {
          if(childrenList.length == 0) {
            return;
          }

          childrenList.forEach(children => {
            this.getScheduleByDevMethodology(children);
          })
        }
      },
      getOverdue(status, dueDateStr) {

          const statusArray = ["OPEN", "TO_DO", "IN_PROGRESS"]

          if(dueDateStr === '') return false;
          if(this.compareDates(this.today, dueDateStr) > 0 && statusArray.includes(status)) {
              return true;
          }

          return false;
      },
      getScheduleByChatter(chatter) {
        // 자신의 스케줄 구하기
        const scheduleInfo = this.getSchedule(chatter.startDate, chatter.dueDate);

        chatter.offset = scheduleInfo.offset;
        chatter.occupancy = scheduleInfo.occupancy;

        chatter.isOverdue = this.getOverdue(chatter.status, chatter.dueDate);
        
        const subChatterList = chatter.subChatterList;
        if(subChatterList === undefined) {
          return;
        } 

        // 자신의 subChatter들을 돌면서 스케줄 구하기
        subChatterList.forEach(item => {
          this.getScheduleByChatter(item);
        })

      },
      getSchedule(startDateStr, endDateStr) {

        // null, undefined를 빈문자열로 초기화
        if(startDateStr === null || startDateStr === undefined) startDateStr = '';
        if(endDateStr === null || endDateStr === undefined) endDateStr = '';

        // 둘다 정해지지 않았다면 기본값 리턴
        if(startDateStr === '' && endDateStr === '') {
          return {offset: 0.0, occupancy: -1};
        }

        // task 시작날짜가 없으면 프로젝트 시작날짜로 초기화
        if(startDateStr === '') {
          startDateStr = this.startDate;
        }

        // task 종료 날짜가 없으면 프로젝트 종료날짜로 초기화
        if(endDateStr === '') {
          endDateStr = this.endDate;
        }
        
        // 프로젝트의 시작날짜부터 task의 시작날짜 사이의 offset
        const projectStartDateObj = new Date(this.startDateFirstDay);
        const projectEndDateObj = new Date(this.endDateLastDay);
        const taskStartDateObj = new Date(startDateStr);
        const taskEndDateObj = new Date(endDateStr);
        // 프로젝트 전체 기간 중 task 기간의 퍼센트 구하기
        
        // task의 일정이 프로젝트 기간을 넘어가지 않도록 조정
        // const validStartDate = Math.max(taskStartDateObj, projectStartDateObj);
        // const validEndDate = Math.min(taskEndDateObj, projectEndDateObj);
        // 프로젝트 전체 일수, 업무 전체 일수 구하여 백분율 구하기
        const totalProjectDays = (projectEndDateObj - projectStartDateObj) / (24 * 60 * 60 * 1000);
        const taskDays = (taskEndDateObj - taskStartDateObj) / (24 * 60 * 60 * 1000);

        const percentage = (taskDays / totalProjectDays).toFixed(3) * 100;

        // 프로젝트 시작부터, task 시작 까지의 offset 구하기
        const offsetDays = (taskStartDateObj - projectStartDateObj) / (24 * 60 * 60 * 1000);
        const offsetPercentage = (offsetDays / totalProjectDays).toFixed(3) * 100;

        return {offset : offsetPercentage, occupancy : percentage};
      },
      formatDateObjectToString(dateObject) {
        const year = dateObject.getFullYear();
        const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObject.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      getExpandableItemCount(wbs) {
        this.$store.commit('wbs/setExpandableItemCount', 0);

        for(let i = 0; i < wbs.length; i++) {
          const devMethodology = wbs[i];
          this.checkExpandableDevMethodology(devMethodology);
        }
      },
      checkExpandableDevMethodology(devMethodology) {
        let isExpandable = false;
        if (devMethodology.chatterList && devMethodology.chatterList.length > 0) {
          isExpandable = true;

          for(let i = 0; i < devMethodology.chatterList.length; i++) {
            this.checkExpandableChatter(devMethodology.chatterList[i]);
          }
        }

        if (devMethodology.children && devMethodology.children.length > 0) {
          isExpandable = true;

          for(let i = 0; i < devMethodology.children.length; i++) {
            this.checkExpandableDevMethodology(devMethodology.children[i]);
          }
        }
        if(isExpandable) {
          this.$store.commit('wbs/setExpandableItemCount', this.expandableItemCount + 1);
        }
      },
      checkExpandableChatter(chatter) {
        let isExpandable = false;

        if (chatter.subChatterList && chatter.subChatterList.length > 0) {
          isExpandable = true;

          for (let i = 0; i < chatter.subChatterList.length; i++) {
            this.checkExpandableChatter(chatter.subChatterList[i]);
          }
        }

        if (isExpandable) {
          this.$store.commit('wbs/setExpandableItemCount', this.expandableItemCount + 1);
        }
      },
    },
      
    }
</script>

<style scoped>

@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');
* {
  font-family: "NanumGothic";
}

.wbs-wrap .card.rounded {
  margin-bottom: 2rem;
  border-radius: 30px !important;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.wbs-wrap .card.rounded>.card-header {
  padding: 10px 0;
  margin: 0 2.0833vw;
}

.wbs-wrap .card.rounded>.card-body {
  padding: calc(2.0833vw - 10px) 2.0833vw 2.0833vw;
}

.wbs-wrap .container-graph {
  display: flex;
  justify-content: center;
  align-items: center;
}

.wbs-wrap .card-deck {
  margin-right: -10px;
  margin-left: -10px;
}

.wbs-wrap .card-deck .card {
  padding: 1px;
  border-radius: 10px;
}

.wbs-wrap .card-deck .card-preview {
  margin: 10px;
}

.wbs-wrap .card .card-header {
  padding-top: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dee2e6 !important;
  color: #2E2E38;
  font-family: NanumGothic;
  font-size: clamp(14px, 0.9375vw, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}

.wbs-wrap .card-preview .card-header {
  display: flex;
  justify-content: space-between;
  height: 57px;
  padding-top: 18px;
  padding-right: 0;
}

.wbs-wrap .card-preview .card-body {
  height: calc(100% - 57px);
}

.wbs-wrap .card-graph {
  padding: 1px;
  cursor: pointer;
  border: 1px solid #dee2e6 !important;
}

.wbs-wrap .card-graph:hover {
  border: 1px solid #747480 !important;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.10);
}

.wbs-wrap .content-text {
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical
}

.wbs-wrap .project-option-label {
  font-size: 15px;
}

.wbs-wrap .project-select-option {
  padding: 0.533rem 2.266rem 0.533rem 1.066rem;
  margin-bottom: 0;
  height: 25px;
  border-radius: 10px;
  color: #2E2E38;
  font-weight: 400;
  line-height: 150%;
  font-size: 18px;
  font-family: 'NanumGothic';
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 12px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  appearance: none;
}
</style>